import React from 'react';
import { Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

interface ImageViewerProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string;
}

const ImageViewer: React.FC<ImageViewerProps> = ({ open, onClose, imageUrl }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" gutterBottom>
          {t('vehicle.details.buttons.viewDashboardPhoto')}
        </Typography>
        <img src={imageUrl} alt={t('vehicle.details.labels.dashboardPhoto')} style={{ width: '100%', height: 'auto' }} />
      </DialogContent>
    </Dialog>
  );
};

export default ImageViewer;